module.exports = __webpack_public_path__ + "static/media/ss10.5d753cf6.jpg";